import { useEffect, useRef } from "react";
import FGField from "./FGField";
import classNames from "classnames";
import { InputCounter } from "../common/InputCounter";

/** @see `<FGField/>` */
export default function FGTextarea(props: JSX.IntrinsicElements["textarea"] & {
  label: string|JSX.Element|JSX.Element[];
  desc?: string|JSX.Element|JSX.Element[];
  /** just keep toggling this value will autofocus the element */
  triggerFocus?: boolean;
  /** defaults to "inset" */
  variant?: "normal" | "inset";
  showMaxLength?: boolean;
}) {
  const ref = useRef<HTMLTextAreaElement>();

  useEffect(() => {
    if (typeof props.triggerFocus !== "undefined") {
      setTimeout(() => (ref.current && ref.current.focus()), 50);
    }
  }, [props.triggerFocus]);

  const newProps = {...props};
  delete newProps.variant;
  delete newProps.triggerFocus;
  delete newProps.showMaxLength;

  return <FGField name={props.name} label={props.label} desc={props.desc} comp="FGTextarea"
    required={props.required}
    className={classNames([
      "fg__textarea",
      {"fg__control--normal": props.variant === "normal"}
    ])}
  >
    <textarea
      ref={ref}
      rows={5}
      id={props.name}
      {...newProps}
    />

    {props.showMaxLength && <div className="fg__char-counter">
      <InputCounter value={props.value ?? ""}
        maxLength={props.maxLength} show={true} staticMode={false}
      />
    </div>}
  </FGField>;
}
